import { CheckboxV2 } from '@insights-ltd/design-library/components';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';

type ToggleOptionsProps = {
  toggleLabel: string;
  isChecked: boolean;
  onToggle: (isChecked: boolean) => void;
};

const ToggleOptions = ({
  toggleLabel,
  isChecked,
  onToggle,
}: ToggleOptionsProps) => {
  return (
    <CheckboxV2
      label={toggleLabel}
      checked={isChecked}
      onClick={() => {
        onToggle(!isChecked);
      }}
      sx={(theme) => ({
        marginLeft: theme.spacing(-1),
        '& span:nth-of-type(2)': {
          paddingLeft: theme.spacing(spacingSizeMap.S),
        },
        height: theme.spacing(4.5),
      })}
      disableRipple
      disableTouchRipple
    />
  );
};

export default ToggleOptions;
